import {
	type PluginLocation,
	type Plugins,
	type PluginValidationResult,
} from '../../../plugins/types';
import { type InvitePeopleData } from '../../../types';
import { type InvitePeoplePluginsAnalytics } from './InvitePeoplePluginsAnalytics';

interface Arguments {
	analytics: InvitePeoplePluginsAnalytics;
	invitePeopleData: InvitePeopleData;
	plugins?: Plugins;
}

/**
 * Allows all plugins to validate its data on submit button click.
 * Allows all plugins to prevent submission depending on `PluginValidationResult`.
 * It returns a successful result when there are no plugins.
 */
export const onValidate = async ({
	analytics,
	invitePeopleData,
	plugins,
}: Arguments): Promise<PluginValidationResult> => {
	const pluginValidationSuccessfulResult: PluginValidationResult = {
		isValid: true,
	};

	if (!plugins) {
		return pluginValidationSuccessfulResult;
	}

	try {
		const onValidatePromises = Object.keys(plugins).map(
			(location: string) =>
				plugins[location as PluginLocation]?.onValidate?.(invitePeopleData) ??
				Promise.resolve(pluginValidationSuccessfulResult),
		);
		const onValidateResults = await Promise.all(onValidatePromises);

		return { isValid: onValidateResults.every(({ isValid }) => isValid) };
	} catch (error) {
		analytics.pluginsValidationFailed({ error: String(error) });

		return {
			isValid: false,
		};
	}
};
